/*
* @requires  middleware/middleware.js
* @requires  seal/seal.js
* @requires  fileseal/fileseal.js
* @requires  monitor/monitor.js
* @requires  zxq3/zxq3.js
* @requires  pdf/pdf.js
* @requires  reader/reader.js
* @requires  ui/ui.js
* @requires  es6.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {
    $m._debug=false;
    $m._ui=null;

    /**
     * 设置调试
     * @param d true}false  打开关闭调试
     */
    function setDebug(d){
        $m._debug=d
    }

    //隐藏日志输出中的密码
    function _hidePassword(s) {
        var substr=new RegExp('/"password":(\s)*"(\w)+"/',"g");
        return s.replace(substr,'"password":"**********"')
    }

    /**
     * 输出日志
     */
    function debug(){
        if($m._debug){
            var arg=["[HebcaMiddle]:"];
            for(var i=0;i<arguments.length;i++){
                if(typeof(arguments[i])==="string"){
                    var tempArg=_hidePassword(arguments[i]);
                    arg.push(tempArg);
                }
                else {
                    arg.push(arguments[i]);
                }
            }

            try
            {
                console.log.apply(this, arg);
            }
            catch (e) {
                //do nothing
            }
        }
    }

    //设置UI实现类
    function setUi(ui){
        $m._ui=ui;
    }

    function getUi(){
        return $m._ui;
    }

    //导出基本函数
    $m.setDebug=setDebug;
    $m.debug=debug;
    $m.setUi=setUi;
    $m.getUi=getUi;

})(HebcaMiddleware);
